import React from 'react';
import AreaListComponent from '../../common/area/AreaListComponent';

class AreaListView extends React.Component{
  render(){
    return <AreaListComponent />
  }
}

export default AreaListView;